const breakpoints = [576, 768, 992, 1280];

export const mq = breakpoints.map((bp) => `@media (min-width: ${bp}px)`);
